// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__QCKuC","title":"Images45_title__1pRLR","images":"Images45_images__30DTP"};